import instance from '@/utils/instance';

//文件下载-post
export function postFilesDownload(params) {
	return instance({
		url: `/webL_api/third/files/download`,
		method: 'post',
		data: params
	});
}

//文件下载-GET
export function getFilesDownload(params) {
	return instance({
		url: `/webL_api/third/files/download/${params}`,
		method: 'get'
	});
}

//文件预览
export function getFilesInfo(params) {
	return instance({
		url: `/webL_api/third/files/info/${params}`,
		method: 'get'
	});
}

//文件预览
export function getFilesPreview(params) {
	return instance({
		url: `/webL_api/third/files/preview/${params}`,
		method: 'get'
	});
}

//文件上传
export function postFilesUpload(params) {
	let formData = new FormData();
	formData.append('fileName', params);
	return instance({
		url: `/webL_api/third/files/uploadFile`,
		method: 'post',
		data: formData
	});
}
